import Skeleton from "@mui/material/Skeleton";

const MarketDetailSkeleton = () => {
  return (
    <>
      <div className="right_wrap market_wrap_main market_Detail_main">
        <div className="market_Detail_wrp">
          <Skeleton variant="text" className="mkt_dt_title" />

          <div className="market_details_card">
            <div className="mrkt_detl_mai_crd">
              <div className="detl_crd_one mrk_lft_sidecrd">
                <Skeleton
                  variant="text"
                  style={{ width: "140px" }}
                  className="dsh_skl_card_title"
                />
                <Skeleton variant="rectangular" className="dsh_skl_card_img" />
                <Skeleton variant="text" className="dsh_skl_card_subtitle" />
                <Skeleton variant="text" className="dsh_skl_card_subcnt" />

                <ul className="mrkt_crd_list">
                  <li>
                    <h6>
                      <Skeleton
                        variant="text"
                        style={{ width: "80px" }}
                        className="dsh_skl_card_title"
                      />
                    </h6>
                    <p>
                      <Skeleton
                        variant="text"
                        style={{ width: "140px" }}
                        className="dsh_skl_card_title"
                      />
                    </p>
                  </li>
                  <li>
                    <h6>
                      <Skeleton
                        variant="text"
                        style={{ width: "80px" }}
                        className="dsh_skl_card_title"
                      />
                    </h6>
                    <p>
                      <Skeleton
                        variant="text"
                        style={{ width: "140px" }}
                        className="dsh_skl_card_title"
                      />
                    </p>
                  </li>
                  <li>
                    <h6>
                      <Skeleton
                        variant="text"
                        style={{ width: "80px" }}
                        className="dsh_skl_card_title"
                      />
                    </h6>
                    <p>
                      <Skeleton
                        variant="text"
                        style={{ width: "140px" }}
                        className="dsh_skl_card_title"
                      />
                    </p>
                  </li>
                  <li>
                    <h6>
                      <Skeleton
                        variant="text"
                        style={{ width: "80px" }}
                        className="dsh_skl_card_title"
                      />
                    </h6>
                    <p>
                      <Skeleton
                        variant="text"
                        style={{ width: "140px" }}
                        className="dsh_skl_card_title"
                      />
                    </p>
                  </li>
                </ul>
                <div className="prpty_inform_wrp">
                  <h6 className="mb-0">
                    <Skeleton
                      variant="text"
                      style={{ width: "150px" }}
                      className="dsh_skl_card_title"
                    />
                  </h6>
                  <ul>
                    <li className="mb-0">
                      <Skeleton
                        variant="text"
                        style={{ width: "80px" }}
                        className="dsh_skl_card_title"
                      />
                      <Skeleton
                        variant="text"
                        style={{ width: "80px" }}
                        className="dsh_skl_card_title"
                      />
                    </li>
                    <li className="mb-0">
                      <Skeleton
                        variant="text"
                        style={{ width: "80px" }}
                        className="dsh_skl_card_title mb-0"
                      />
                      <Skeleton
                        variant="text"
                        style={{ width: "80px" }}
                        className="dsh_skl_card_title mb-0"
                      />
                    </li>
                  </ul>
                </div>
                <div className="mrk_button_cdone">
                  <Skeleton variant="rectangular" className="mkt_dt_skl_btn" />{" "}
                  <Skeleton variant="rectangular" className="mkt_dt_skl_btn" />
                </div>
              </div>

              <div className="mrk_rgt_side_wrp">
                <div className="detl_crd_two mrk_rgt_sidecrd">
                  <div className="selct_infr_wrp">
                    <div className="infrm_cont_main">
                      <p>
                        <Skeleton
                          variant="text"
                          style={{ width: "140px" }}
                          className="dsh_skl_card_title"
                        />
                      </p>
                      <span>
                        <Skeleton
                          variant="text"
                          style={{ width: "140px" }}
                          className="dsh_skl_card_title"
                        />
                      </span>
                    </div>
                    <div className="infrm_cont_main">
                      <p>
                        <Skeleton
                          variant="text"
                          style={{ width: "140px" }}
                          className="dsh_skl_card_title"
                        />
                      </p>
                      <span>
                        <Skeleton
                          variant="text"
                          style={{ width: "140px" }}
                          className="dsh_skl_card_title"
                        />
                      </span>
                    </div>
                    <div className="infrm_cont_main">
                      <p>
                        <Skeleton
                          variant="text"
                          style={{ width: "140px" }}
                          className="dsh_skl_card_title"
                        />
                      </p>
                      <span>
                        <Skeleton
                          variant="text"
                          style={{ width: "140px" }}
                          className="dsh_skl_card_title"
                        />
                      </span>
                    </div>
                  </div>

                  <div>
                    <label>
                      <Skeleton
                        variant="text"
                        style={{ width: "100px" }}
                        className="mkt_dt_cnt mb-0"
                      />
                    </label>
                    <Skeleton
                      variant="text"
                      style={{ width: "100%", minHeight: "100px" }}
                      className="mkt_dt_cnt"
                    />
                  </div>
                  <div className="amount_details_mrkt">
                    <div className="amount_details_item">
                      <h6>
                        <Skeleton
                          variant="text"
                          style={{ width: "140px" }}
                          className="mkt_dt_cnt"
                        />
                      </h6>
                      <p>
                        <Skeleton
                          variant="text"
                          style={{ width: "140px" }}
                          className="mkt_dt_cnt"
                        />
                      </p>
                    </div>
                    <div className="amount_details_item">
                      <h6>
                        <Skeleton
                          variant="text"
                          style={{ width: "140px" }}
                          className="mkt_dt_cnt"
                        />
                      </h6>
                      <p>
                        <Skeleton
                          variant="text"
                          style={{ width: "140px" }}
                          className="mkt_dt_cnt"
                        />
                      </p>
                    </div>
                    <div className="amount_details_item">
                      <h6>
                        <Skeleton
                          variant="text"
                          style={{ width: "140px" }}
                          className="mkt_dt_cnt"
                        />
                      </h6>
                      <p>
                        <Skeleton
                          variant="text"
                          style={{ width: "140px" }}
                          className="mkt_dt_cnt"
                        />
                      </p>
                    </div>
                  </div>
                  <Skeleton variant="text" className="dsh_skl_card_btn" />
                </div>
                <div className="mrkt_detlTab_wrp mrk_rgt_sidecrd">
                  <Skeleton variant="text" className="mkt_dt_title mb-3" />
                  <div className="mrkt_dtl_tab_main">
                    <ul className="mrkt_dtl_tab_ul d-flex flex-wrap">
                      <button className="nav-link">
                        <Skeleton variant="text" className="mkt_dt_tab" />
                      </button>
                      <button className="nav-link">
                        <Skeleton variant="text" className="mkt_dt_tab" />
                      </button>
                      <button className="nav-link">
                        <Skeleton variant="text" className="mkt_dt_tab" />
                      </button>
                      <button className="nav-link">
                        <Skeleton variant="text" className="mkt_dt_tab" />
                      </button>
                    </ul>

                    <Skeleton variant="text" className="mkt_dt_title mt-2" />
                    <Skeleton variant="text" className="mkt_dt_title my-3" />
                    <Skeleton variant="text" className="mkt_dt_title" />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default MarketDetailSkeleton;
